import type { Color } from "../../types";
import type { HasAverageColor } from "../HasAverageColor";
import type { HasBackgroundColor } from "../HasBackgroundColor";
import type { VirtualViewportPixelAccessor } from "../VirtualViewportPixelAccessor";
import { AbstractVirtualPixelDecorator } from "./AbstractVirtualPixelDecorator";

/**
 * VerticalTile virtual pixel decorator.
 */
export class VerticalTileVirtualPixel<
  DecoratedType extends VirtualViewportPixelAccessor &
    HasAverageColor &
    HasBackgroundColor
> extends AbstractVirtualPixelDecorator<DecoratedType> {
  /**
   * @inheritDoc
   */
  getVirtualPixelColor(x: number, y: number): Color {
    if (x < 0 || x >= this.width) {
      return this.decorated.getBackgroundColor();
    }
    const rx = x % this.width;
    const ry = y % this.height;

    return this.decorated.getPixelColor(
      rx < 0 ? this.width + rx : rx,
      ry < 0 ? this.height + ry : ry
    );
  }
}
